import React from 'react';

export default function AuthInput({
  label,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  error,
  icon: Icon,
  trailing,
  autoComplete,
}) {
  const borderClass = error
    ? 'border-red-400 focus:border-red-500 focus:ring-red-500/15'
    : 'border-gray-200 focus:border-teal-600 focus:ring-teal-600/15';

  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={name} className="text-sm font-semibold text-gray-700">
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        {Icon && (
          <Icon
            className={`absolute left-3.5 w-5 h-5 pointer-events-none transition-colors ${
              value ? 'text-teal-600' : 'text-gray-400'
            }`}
            strokeWidth={1.75}
            aria-hidden="true"
          />
        )}
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          required={required}
          autoComplete={autoComplete}
          className={`w-full rounded-xl border-2 bg-white py-3 text-[15px] text-gray-900 outline-none transition-[border-color,box-shadow] duration-150 focus:ring-4 ${Icon ? 'pl-11 pr-11' : 'px-4'} ${borderClass}`.trim()}
        />
        {trailing && (
          <div className="absolute right-3.5 flex items-center">{trailing}</div>
        )}
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
